import { render, staticRenderFns } from "./ServiceChargeView.vue?vue&type=template&id=27a88e50&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ServiceChargeView.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeView.vue?vue&type=style&index=0&id=27a88e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a88e50",
  null
  
)

component.options.__file = "ServiceChargeView.vue"
export default component.exports